module.exports = __webpack_public_path__ + "files/sharepoint-2010-configuration.856ac5b6.pdf";